
<template>
  <div class="title-home row" :style="style">
    <v-divider :class="no_left ? 'no_left' : ''" class="divider-left"></v-divider>
    <div class="title-home__text-wrapper" >
      <span class="title-home__text">
        <slot></slot>
      </span>
      <v-divider class="divider-right"></v-divider>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
export default {

    name: 'UITitleLine',

    props: {
      no_left: {
        type: Boolean,
        default: false
      },
      text_decoration: {
        type: String,
        default: 'none'
      },
      margin_top: {
        type: String,
        default: '50px'
      },
      margin_bottom: {
        type: String,
        default: '50px'
      },
    },

    computed: {
      style () {
        return {
          '--margin-top': this.margin_top,
          '--margin-bottom': this.margin_bottom,
          '--decoration': this.text_decoration
        }
      }
    },
}
</script>

<style>
  .title-home .divider-left{
    margin-right: 10px;
  }
  .title-home .no_left{
    opacity: 0;
  }
  .title-home .divider-right{
    margin-left: 10px;
  }
  .title-home__text{
    text-transform: uppercase;
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 1.5em;
    
    text-decoration-line: var(--decoration);
    color: #000000;
  }
  .title-home__text-wrapper{
    display: flex;
    align-items: center;
  }
  .title-home{
    margin-top: var(--margin-top);
    margin-bottom: var(--margin-bottom);
    display: grid;
    grid-template-columns: 2fr 4fr 5fr;
    grid-gap: 0;
    align-items: center;
  }
  @media (max-width: 1650px) {
    .title-home__text{
      font-size: 32px;
    }
  }
  @media (max-width: 1350px) {
    .title-home__text{
      font-size: 27px;
    }
  }
  @media (max-width: 850px) {
    .title-home__text{
      font-size: 20px;
    }
    .title-home{
      grid-template-columns: 1fr 3fr 2fr;
    }
  }
</style>



// WEBPACK FOOTER //
// UITitleLine.vue?1110ed73